// src/store/services/participantes.js

import feathersClient, { makeServicePlugin, BaseModel } from "../../feathers-client";

class Participantes extends BaseModel { }
Participantes.modelName = "Participantes";
Participantes.instanceDefaults = () => {
  return {
    metodosPago: {
      stripe: true,
      paypal: true,
      mercadopago: true,
    },
    entradas: [],
    variables: {},
    precio: {
      eur: null,
      usd: null,
      ars: null,
    }
  };
};



const servicePath = "participantes"; // Asegúrate de que coincida con el nombre del servicio en el backend

const servicePlugin = makeServicePlugin({
  Model: Participantes,
  service: feathersClient.service(servicePath),
  servicePath,
});

export default servicePlugin;
